import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Chip,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

const StaffsTable = ({
  rows,
  roles,
  setOpenModal,
  onDeleteStaff,
  setSelectedStaff,
}) => {
  const statusColors = {
    Active: "success",
    Inactive: "error",
  };
//console.log(rows)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRole, setSelectedRole] = useState("");

  const filteredRows = rows?.filter(
    (row) => !selectedRole || Number(row.roleID) === Number(selectedRole)
  );


  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onHandleEditStaff = (staff) => {
    console.log(staff);
    setOpenModal(true);
    setSelectedStaff(staff);
    console.log(staff);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", mt: 2, p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <FormControl fullWidth>
          <InputLabel>Filter by Role</InputLabel>
          <Select
            value={selectedRole}
            label="Filter by Role"
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <MenuItem value="">
              <em>All Roles</em>
            </MenuItem>
            {roles?.map((role) => (
              <MenuItem key={role.roleID} value={role.roleID}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Name</strong>
              </TableCell>
              <TableCell>
                <strong>Email</strong>
              </TableCell>
              <TableCell>
                <strong>Phone</strong>
              </TableCell>
              <TableCell>
                <strong>Role</strong>
              </TableCell>
              <TableCell>
                <strong>Branch</strong>
              </TableCell>
              {/* <TableCell>
                <strong>Generate Code</strong>
              </TableCell> */}
              <TableCell>
                <strong>Status</strong>
              </TableCell>
              <TableCell>
                <strong>Action</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((row, i) => (
                <TableRow key={i}>
                  <TableCell>{row.fullName}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.phone}</TableCell>
                  <TableCell>{row?.roleName?.toUpperCase()}</TableCell>
                  <TableCell>{row?.branchName}</TableCell>
                  {/* <TableCell>{row?.activationCode?.toUpperCase()}</TableCell> */}
                  <TableCell>
                    <Chip
                      label={row.status == 1 ? "Active" : "Inactive"}
                      color={
                        statusColors[
                          row.status == 1
                            ? "Active"
                            : ("Inactive" as keyof typeof statusColors)
                        ]
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        onClick={() => onHandleEditStaff(row)}
                        color="primary"
                      >
                        EDIT
                      </Button>
                      {/* <Button
                        onClick={() => onDeleteStaff(row)}
                        color="primary"
                      >
                        DELETE
                      </Button> */}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={filteredRows ? filteredRows?.length : 0}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        rowsPerPageOptions={[10, 25, 50]}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default StaffsTable;
